<!--suppress ALL -->

<template>
  <div class="game-row-container pt-4 ">
    <v-row align="center" justify="center" class="game-row">
      <v-col cols="12" md="5" class="textGameName text-center">
        <v-row align="center">
          <v-img
              class="row-img"
              :src="img"
              max-width="90"
              max-height="90"
              :lazy-src="img"
              :eager="true"
              transition="true"
          />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on">
							{{ game.times_played }}
						</span>
            </template>
            <span class="assistant">{{ $t("generics.times_played") }}</span>
          </v-tooltip>
          <v-col cols="6" md="9">
          <span class="mb-2">{{ game.name }}</span>

          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" md="4" class="textGameType text-center">
        <span class=" hidden-sm-and-down mb-2">{{ name }}</span>
      </v-col>
      <v-col cols="12" md="3" class="text-center d-flex justify-center">
        <v-tooltip top v-if="isPro && game.type.can_live_edit">
          <template #activator="{ on, attrs }">
            <div v-bind="attrs"
                 v-on="on">
              <v-switch
                  class="my-1"

                  elevation="0"
                  color="#ed217c"
                  small
                  v-model="game.store_score"
              />
            </div>
          </template>
          <span>איסוף תוצאות</span>
        </v-tooltip>
        <div class="actions-col">
          <div class="action-buttons">
						<span v-if="canEdit">
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
                      fab
                      small
                      color="transparent"
                      elevation="0"
                      class="mb-3 editBtn"
                      @click="onEdit"
                      v-bind="attrs"
                      v-on="on"
                  />
								</template>
								<span>{{ $t("generics.edit") }}</span>
							</v-tooltip>
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
                      fab
                      small
                      color="transparent"
                      elevation="0"
                      class="removeBtn mb-2"
                      @click="doRemove(game)"
                      v-bind="attrs"
                      v-on="on"
                  />
								</template>
								<span>{{ $t("generics.delete") }}</span>
							</v-tooltip>
						</span>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    small
                    v-bind="attrs"
                    link
                    elevation="0"
                    color="transparent"
                    class="mb-2 shareBtn"
                    v-on="on"
                    @click.prevent.stop="openShareDialog"
                >
                </v-btn>
              </template>
              <span>{{ $t("generics.share") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-btn
                    fab
                    small
                    class="mb-2 duplicateBtn"
                    elevation="0"
                    color="transparent"
                    v-bind="attrs"
                    v-on="on"
                    @click.prevent.stop="duplicateGame(game)"
                >
                </v-btn>
              </template>
              <span>{{ $t("generics.duplicate") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="isPro">
              <template #activator="{ on, attrs }">
                <v-btn
                    fab
                    small
                    class="mb-2"
                    icon
                    elevation="0"
                    color="#ed217c"
                    v-bind="attrs"
                    v-on="on"
                    @click.prevent.stop="openDashboard(game)"
                >
                  <v-icon>mdi-file-table-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>טבלת תוצאות</span>
            </v-tooltip>

            <game-dashboard :game="game" v-model="showDashboard" v-if="showDashboard" />
          </div>
          <div class="play-button-container">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    small
                    v-bind="attrs"
                    link
                    elevation="0"
                    color="#f03573"
                    class="me-2 play-button"
                    v-on="on"
                    :href="game.link"
                    target="_blank"
                >
                  <v-icon light color="#FFFFFF" x-large> mdi-play</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("generics.play") }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { types } from "src/store/modules/Game.module";
import RowMixin from "src/mixins/RowMixin";
import GameDashboard from "src/view/dashboard/GameDashboard";
import { gameTypeTranslate } from "src/helpers/Utilities"

export default {
  name: "GameRow",
  components: { GameDashboard },
  props: {
    game: { required: true },
  },
  mixins: [new RowMixin(types, "game")],
  data() {
    return {
      showDashboard: false,
    };
  },
  computed: {
    isPro() {
      return this.$store.getters.isPro;
    },
    auth() {
      return this.$store.state.AuthModule.user;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    canEdit() {
      return this.isManager || this.game.company_id == this.auth.company_id;
    },
    deleteTitle() {
      return this.$t("pages.createGame.deleteGame") + this.game.name + "?";
    },
    basicUrl() {
      return this.$store.state.ConfigModule.request.baseUrl;
    },
    img() {
      return (
          (this.gameType && this.gameType.square_logo) ||
          "img/game-ratings-featured8.png"
      );
    },
    gameType() {
      return this.game.type;
    },
    name() {
      return this.game?.type?.name ? gameTypeTranslate(this.game.type.name) : "";
    }
  },
  methods: {
    openDashboard() {
      this.showDashboard = true;
    },
    openShareDialog() {
      this.$emit("share", this.game);
    },
    editQuestions() {
      this.beforeRouter();
    },
    async doRemove(game) {
      const response = await this.$notification.warning(
          this.$t("pages.mygames.popupDelete") + " " + this.game.name + "?", "",
          {
            confirmButtonText: this.$t("generics.accept"),
            cancelButtonText: this.$t("generics.cancel"),
          }
      );
      if (response.isConfirmed) {
        await this.$store.dispatch(types.REMOVE, game);
        this.$store.dispatch(types.COUNT);
        this.$notification.success(this.$t('pages.createGame.deleteSuccess'));
      }
    },
    onEdit() {
      this.$emit("edit", this.game);
    },
    beforeRouter() {
      this.$store.commit(types.GET, this.game);
    },
    duplicateGame(game) {
      this.$emit("duplicate", game);
    },
    downloadJson(questions) {
      this.downloadObjectAsJson(questions, "questions");
    },
    downloadObjectAsJson(exportObj, exportName) {
      var dataStr =
          "data:text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(exportObj));
      var downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", exportName + ".json");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },
  },
  watch: {
    "game.store_score"(val, oldVal) {
      if (!!this.game.store_score !== !!oldVal) {
        this.$store.dispatch(types.SAVE, this.game);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.game-row-container {
  background: white;
  border-radius: 20px;
}

.row-img {
  width: 85px;
  height: 85px;
  border: 3px solid white;
  border-radius: 50%;
}


.tr {
  display: flex;
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}

.singleRow {
  position: relative;
  border: 2px solid #fa6655;
  border-radius: 30px;
  height: 70px;
  margin-top: 6px;
  position: relative;
  background-color: white;
  /* box-shadow: -1px 1px #c8c8c9, -2px 2px #c8c8c9, -3px 3px #c8c8c9,
    -4px 4px #c8c8c9, -5px 5px #c8c8c9; */

  .row-img {
    position: absolute;
    right: -5px;
    top: -5px;
  }

  .times-played {
    position: absolute;
    right: 100px;
    top: 20px;
  }
}

.zIndex {
  position: relative;
  z-index: 3;
  right: 20px;
}

.actions-col {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.action-buttons {
  flex-grow: 1;
}

.play-button {
  border-radius: 50%;
  height: 50px;
  width: 50px;
}

.editBtn {
  background-image: url("/img/edit.png");
  background-repeat: no-repeat;
  background-position: center center;
}

.editJsonBtn {
  background-image: url("/img/edit_json.png");
  background-repeat: no-repeat;
  background-position: center center;
}

.duplicateBtn {
  background-image: url("/img/duplicate.png");
  background-repeat: no-repeat;
  background-position: center center;
}

.removeBtn {
  background-image: url("/img/delete.png");
  background-repeat: no-repeat;
  background-position: center center !important;
}

.shareBtn {
  background-image: url("/img/share.png");
  background-repeat: no-repeat;
  background-position: center center !important;
}

.textGameName {
  color: #fa6655;
  font-size: 1.2rem;
}

.textGameType {
  color: #374d8f;
  font-size: 1.2rem;
}
</style>
